import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  bold: {
    fontWeight: 'bold',
  },
  container: {
    marginTop: theme.spacing(8),
    width: '100%',
    [theme.breakpoints.down('lg')]: {
      padding: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  },
  title: {
    alignItems: 'center',
    justifyContent: 'center',
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
    },
  },
  icon: {
    marginRight: theme.spacing(0.5),
  },
}));

export default useStyles;
